import { Grid } from "@mui/material";
import { ReferenceInput, required, TextInput, AutocompleteInput } from "react-admin";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
          filter={{ filterByUser: true }}
          validate={required()}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="name"
            label="Катедра"
            fullWidth
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
